import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { AuthProvider } from './context/AuthContext';
import ForgotPassword from './routes/auth/ForgotPassword';
import Login from './routes/auth/Login';
import ResetPassword from './routes/auth/ResetPassword';
import Signup from './routes/auth/Signup';
import VerifyEmail from './routes/auth/VerifyEmail';
import PrivateRoutes from './routes/portal/PrivateRoutes';
import ArtPage from './routes/public/ArtPage';
import AtharvaLanding from './routes/public/AtharvaLanding';
import BiogasPage from './routes/public/BiogasPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AtharvaLanding />} />
          <Route path="/projects/biogas" element={<BiogasPage />} />
          <Route path="/projects/art" element={<ArtPage />} />
          <Route path="/biogas" element={<Navigate to="/projects/biogas" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/app/*" element={<PrivateRoutes />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
